// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"059a5fd3","455":"d4efcd3d"}[chunkId] + ".chunk.js";
};